type FaqConceptArticleId =
    | 'que-es-un-escandallo'
    | 'como-calcular-coste-de-un-plato'
    | 'food-cost-y-margen-bruto-restaurante'
    | 'que-food-cost-deberia-tener-restaurante-espana'
    | 'coste-teorico-vs-coste-real-cocina'

export const FAQ_CONCEPT_KEYS = ['1', '2', '3', '4', '5', '6'] as const

export type FaqConceptKey = (typeof FAQ_CONCEPT_KEYS)[number]

/** Learn article ids for FAQ concept questions (`faqPage.groups.concepts.items.*`). */
export const FAQ_CONCEPT_ARTICLE_IDS = {
    1: 'que-es-un-escandallo',
    2: 'food-cost-y-margen-bruto-restaurante',
    3: 'coste-teorico-vs-coste-real-cocina',
    4: 'food-cost-y-margen-bruto-restaurante',
    5: 'que-food-cost-deberia-tener-restaurante-espana',
    6: 'coste-teorico-vs-coste-real-cocina',
} as const satisfies Record<FaqConceptKey, FaqConceptArticleId>
